// extracted by mini-css-extract-plugin
module.exports = {"poll":"styles_poll__2XiZn","option":"styles_option__289uh","label":"styles_label__3t3jj","count":"styles_count__2uuWk","track":"styles_track__25g-_","fill":"styles_fill__1SWXq"};